import { Heading } from '@/src/tailwindui/heading';
import {
    DevicePhoneMobileIcon,
    EnvelopeIcon,
    PaintBrushIcon,
    PhotoIcon,
    PrinterIcon,
} from '@heroicons/react/24/outline';
import React from 'react';
import { Link } from 'react-router-dom';

const roadmapItems = [
    {
        icon: <PhotoIcon className="size-5 text-black dark:text-gray-300" />,
        title: 'Gallery management',
        status: 'in progress',
    },
    {
        icon: <EnvelopeIcon className="size-5 text-black dark:text-gray-300" />,
        title: 'Whitelabel email addresses and gallery links',
        status: 'planned',
    },

    {
        icon: (
            <DevicePhoneMobileIcon className="size-5 text-black dark:text-gray-300" />
        ),
        title: 'Device Telemetry and Management',
        status: 'planned',
    },
    {
        icon: (
            <PaintBrushIcon className="size-5 text-black dark:text-gray-300" />
        ),
        title: 'Customize processing for Clickerbooth experiences',
        status: 'planned',
    },
    {
        icon: <PrinterIcon className="size-5 text-black dark:text-gray-300" />,
        title: 'Clickerbooth Printing',
        status: 'planned',
    },
];

export default function Roadmap() {
    return (
        <div className="mx-auto max-w-4xl">
            <div>
                <Heading className="text-3xl md:text-4xl plex-sans">
                    Roadmap
                </Heading>
                <p className="text-muted-foreground plex-sans text-[#000] dark:text-[#fff]">
                    Features and updates we are planning to release
                </p>
            </div>
            <div className="mt-8">
                <ul>
                    {roadmapItems.map((item) => (
                        <li key={item.title}>
                            <div className="flex flex-row justify-between py-2 border-b border-gray-700 dark:border-gray-200 items-center">
                                <div className="flex flex-row gap-2">
                                    {item.icon}
                                    <div className="text-md text-[#000] dark:text-[#fff] lowercase plex-sans-light">
                                        {item.title}
                                    </div>
                                </div>
                                <div className="flex-1" />
                                <div className="mt-2 text-[#000] dark:text-[#fff] flex flex-row gap-2 monospace-font text-sm">
                                    {item.status === 'planned' && (
                                        <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">
                                            {item.status}
                                        </span>
                                    )}
                                    {item.status === 'in progress' && (
                                        <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset">
                                            {item.status}
                                        </span>
                                    )}
                                    {item.status === 'done' && (
                                        <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-green-700/10 ring-inset">
                                            {item.status}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className="mt-8">
                    <a
                        href="https://savory-baroness-9f0.notion.site/1cf256f15b7380189233fa28fe850bc9?pvs=105"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500"
                    >
                        Have a feature request?
                    </a>
                </div>
            </div>
        </div>
    );
}
